import { gql } from '@apollo/client';

export const UPDATE_CREW_MEMBER = gql`
	mutation UpdateCrewMember($id: ID!, $input: CrewMemberInfoInput!) {
		updateCrewMemberInfo(id: $id, input: $input) {
			id
			phone
		}
	}
`;
